import { useEffect, useRef, useState } from "react";
import { RED } from "@/components/quote/docKit";
import { BomTable, DocTopLine, QuoteHeader, Summary } from "@/components/quote/QuoteTop";
import { BasePackage, Payment, PrivilegePackage, ReferenceImage, Terms } from "@/components/quote/QuoteBottom";

const DOC_W = 794;

export const docTitle = (d) => `GN PC Quotation ${d.fyLabel} ${d.salesRepCode} ${d.quarter} Rev-${d.versionNumber} ${d.quoteNo}`;

export function QuoteDocView({ data }) {
  const ref = useRef(null);
  const [zoom, setZoom] = useState(1);
  useEffect(() => {
    const fit = () => ref.current && setZoom(Math.min(1, ref.current.clientWidth / DOC_W));
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);
  const t = data.template;
  return (
    <div ref={ref} className="w-full max-w-[794px]">
      <div className="print-area quote-doc bg-white text-zinc-900 shadow-sm p-5 font-[Inter]" style={{ width: DOC_W, zoom }} data-testid="quote-preview">
        <DocTopLine d={data} />
        <div className="border" style={{ borderColor: RED }}>
          <QuoteHeader d={data} t={t} />
          <div className="px-4 pb-4"><BomTable d={data} t={t} /><Summary d={data} t={t} />
            <BasePackage d={data} t={t} /><PrivilegePackage d={data} t={t} /></div>
        </div>
        <ReferenceImage d={data} t={t} />
        <Payment d={data} t={t} />
        <Terms t={t} />
      </div>
    </div>
  );
}
